import { useFullLesson, useFullLessonPublic } from '../features/lessons/lessonQueries';
import { useShortFormContentPublic, useShortFormContent } from '../features/shortContent/shortContentQueries';
export const useLesson = (lessonId, isPublic = false) => {
  const {
    lesson,
    lessonLoading,
    lessonError
  } = useFullLesson({
    variables: {
      lessonId
    },
    options: {
      skip: isPublic || !lessonId
    }
  });
  const {
    lesson: publicLesson,
    lessonLoading: publicLessonLoading,
    lessonError: publicLessonError
  } = useFullLessonPublic(lessonId, !isPublic || !lessonId);
  return {
    lesson: lesson || publicLesson,
    lessonLoading: lessonLoading || publicLessonLoading,
    lessonError: lessonError || publicLessonError
  };
};
export const useShorts = (shortId, isPublic = false) => {
  const {
    shortFormContent,
    shortFormContentLoading,
    shortFormContentError
  } = useShortFormContent(shortId, isPublic || !shortId);
  const {
    shortFormContent: publicShortFormContent,
    shortFormContentLoading: publicShortFormContentLoading,
    shortFormContentError: publicShortFormContentError
  } = useShortFormContentPublic(shortId, !isPublic || !shortId);
  return {
    shortFormContent: shortFormContent || publicShortFormContent,
    shortFormContentLoading: shortFormContentLoading || publicShortFormContentLoading,
    shortFormContentError: shortFormContentError || publicShortFormContentError
  };
};